export enum BC_NAME_SYNC {
  PointsCloudContents = 'PointsCloudContents',
  AlignmentContents = 'AlignmentContents',
  PanoramaContents = 'PanoramaContents',
  PlanarContents = 'PlanarContents',
  ClassificationContents = 'ClassificationContents',
  Map2DPaneContent = 'Map2DPaneContent',
}
